import { render, staticRenderFns } from "./my-footer.vue?vue&type=template&id=bb3fd4d8&scoped=true"
import script from "./my-footer.vue?vue&type=script&lang=js"
export * from "./my-footer.vue?vue&type=script&lang=js"
import style0 from "./my-footer.vue?vue&type=style&index=0&id=bb3fd4d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3fd4d8",
  null
  
)

export default component.exports